import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AuthState, SetCredentialsPayload } from '../features/auth/types';

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isInitialized: false,
  interviews: undefined,
  totalAllowedInterviews: undefined,
  isQuotaBannerDismissed: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (
      state,
      action: PayloadAction<SetCredentialsPayload>
    ) => {
      state.user = action.payload.user;
      state.interviews = action.payload.interviews;
      state.totalAllowedInterviews = action.payload.totalAllowedInterviews;
      state.isAuthenticated = true;
      state.isInitialized = true;
      state.isQuotaBannerDismissed = false;
      localStorage.setItem('hasSession', 'true');
    },
    dismissQuotaBanner: (state) => {
      state.isQuotaBannerDismissed = true;
    },
    setAuthInitialized: (state) => {
      state.isInitialized = true;
    },
    logout: (state) => {
      state.user = null;
      state.interviews = undefined;
      state.totalAllowedInterviews = undefined;
      state.isAuthenticated = false;
      state.isInitialized = false;
      state.isQuotaBannerDismissed = false;
      localStorage.removeItem('hasSession');
    },
  },
});

export const {
  setCredentials,
  dismissQuotaBanner,
  setAuthInitialized,
  logout,
} = authSlice.actions;
export default authSlice.reducer;
